import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HeaderComponent} from './header/header.component';
import {SidebarComponent} from './sidebar/sidebar.component';
import {FooterComponent} from './footer/footer.component';
import {PageComponent} from './page/page.component';
import {routing} from '../app.routing';
import {SharedTranslationModule} from '../shared/change-language/shared-translation.module';
import {ChangeLanguageModule} from '../shared/change-language/change-language.module';
import {TinvPharmacySaleService} from '../inventory/tinv-pharmacy-sale/tinv-pharmacy-sale.service';

@NgModule({
    imports: [
        CommonModule, routing, SharedTranslationModule, ChangeLanguageModule
    ],
    exports: [HeaderComponent, SidebarComponent, FooterComponent, PageComponent],
    declarations: [HeaderComponent, SidebarComponent, FooterComponent, PageComponent],
    providers: [TinvPharmacySaleService]
})
export class LayoutModule {
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/layout/layout.module.ts